module.exports = __webpack_public_path__ + "img/t1.4a74e542.png";